import { apiInstance } from '../utils/axiosConfig';
import { Exercise } from '../types/exercises';

const getAllExercises = async (): Promise<Exercise[]> => {
  const res = await apiInstance().get('/exercise');
  return res.data;
};

export const ExercisesAPI = { getAllExercises };
